import styled from "styled-components";

export const ErrorText = styled.p`
	color: #e02020;
	font-size: 12px;
	font-weight: 500;
	letter-spacing: 0.5px;
	line-height: 18px;
`;
